import gql from "graphql-tag";
import { quoteFragment, serviceFragment } from "./fragments";

export const clientByTokenQueryFragment = gql`
	fragment clientByTokenQueryFragment on Client {
		_id
		key
	}
`;

export const leadByTokenQueryFragment = gql`
	${quoteFragment}
	fragment leadByTokenQueryFragment on Lead {
		_id
		key
		answers {
			_id
			answers
			values
			description
			tag_name
		}
		quotes(filter: $quotesFilter) {
			...quoteFragment
		}
		created_at
	}
`;

export const searchByProfileUriQueryFragment = gql`
	${serviceFragment}
	fragment searchByProfileUriQueryFragment on Search {
		response {
			... on SearchByProfileUriResponse {
				cityServiceStat {
					active
					service {
						phrase
						name
						url
					}
				}
				redirect_to
				credentials: provider_credentials {
					category
					issuedAt: issued_at
					number
					name
					title
					type
					state
					organization
					education {
						major
						degree
					}
					verifiedAt: verified_at
					expiresAt: expires_at
					capacity: capacity_value
					validationUrl: validation_url
					work_experience {
						year_range
					}
				}
				provider_questions_answers {
					_id
					description
					text
					answers {
						_id
						value
					}
				}
				provider {
					... on SearchByProfileUriResponseProvider {
						estimated_price(answerKeyFilters: $answerKeyFilters) {
							total
							unit
							description
						}

						provider {
							_id
							business_location {
								city
								state
								address
								zip
								address2
								lat
								lng
							}
							hours {
								timezone
								monday {
									active
									start
									stop
								}
								tuesday {
									active
									start
									stop
								}
								wednesday {
									active
									start
									stop
								}
								thursday {
									active
									start
									stop
								}
								friday {
									active
									start
									stop
								}
								saturday {
									active
									start
									stop
								}
								sunday {
									active
									start
									stop
								}
							}
							phone
							noIndex
							metrics {
								hires
								reviews_avg
								reviews_count
								reviews_five_star_count
								reviews_four_star_count
								reviews_three_star_count
								reviews_two_star_count
								reviews_one_star_count
							}
							award {
								online
								top_pro
								high_demand
							}
							key
							first_name
							last_name
							company_name
							company_founded
							company_employees
							company_website
							image(approved: true) {
								hash
								value
							}
							social {
								facebook
								instagram
								linkedin
								twitter
								youtube
								yelp
								google
							}
							services {
								_id
								key
								name
								name_proper
								phrase
								url
							}
							qa {
								question
								answer
							}
							intro
							profile {
								city {
									url
									name
									active
									state
								}
								service {
									phrase
									hide
									url
									name
									active
								}
								slug
							}
							location {
								city
								state
								zip
							}
							verified {
								badge
								background
								email
								phone
							}
							media(approved: true) {
								key
								approved
								media_type
								picture {
									caption
									hash
									value
								}
								video {
									caption
									embed
									hash
									link
									platform
									thumbnail
									value
								}
								created_at
							}
							accepted_payment_types
							best_review {
								rating
							}
							worst_review {
								rating
							}
							reviews(filter: { active: true }, sort: { created_at: -1 }) {
								_id
								author
								message {
									body
								}
								# service {
								# 	name
								# }
								rating
								client {
									_id
									image {
										hash
										value
									}
								}
								media: images(approved: true) {
									picture {
										value
									}
								}
								# media {
								# 	picture {
								# 		hash
								# 		value
								# 		original
								# 		caption
								# 	}
								# 	video {
								# 		embed
								# 		platform
								# 		hash
								# 		caption
								# 		link
								# 		thumbnail
								# 	}
								# }
								comments {
									from_client
									from_provider
									message
									created_at
								}
								verified
								created_at
							}
							claimed
							track {
								source
							}
							is_available
						}
					}
				}

				target_service {
					...serviceFragment
				}

				searched_midtail {
					...serviceFragment
				}
				searched_location {
					city
					state
				}

				midtail_affinities {
					affinity {
						...serviceFragment
					}
				}
				city {
					active
					_id
					state
					name
					url
				}
				popular_services {
					_id
					phrase
					url
				}
				nearby_cities {
					name
					url
				}
				related_services {
					phrase
					name
					url
				}
			}
		}
	}
`;

// export const searchQueryFragment = gql`
// 	fragment searchQueryFragment on Search {
// 		response {
// 			... on SearchByProfileUriResponse {
// 				estimated_price(answerKeyFilters: $answerKeyFilters) {
// 					total
// 					unit
// 				}
// 				provider {
// 					_id
// 					phone
// 					metrics {
// 						hires
// 						reviews_avg
// 						reviews_count
// 					}
// 					award {
// 						online
// 						top_pro
// 						high_demand
// 					}
// 					key
// 					first_name
// 					last_name
// 					company_name
// 					company_founded
// 					company_employees
// 					image(approved: true) {
// 						hash
// 						value
// 					}
// 					social {
// 						facebook
// 						instagram
// 						linkedin
// 						twitter
// 						youtube
// 						yelp
// 					}
// 					services {
// 						_id
// 						key
// 						name
// 						phrase
// 						url
// 					}
// 					qa {
// 						question
// 						answer
// 					}
// 					intro
// 					profile {
// 						city {
// 							url
// 							active
// 							name
// 						}
// 						service {
// 							phrase
// 							active
// 							url
// 						}
// 						slug
// 					}
// 					location {
// 						city
// 						state
// 						zip
// 					}
// 					verified {
// 						badge
// 						background
// 						email
// 						phone
// 					}
// 					media(approved: true) {
// 						key
// 						approved
// 						media_type
// 						picture {
// 							caption
// 							hash
// 							value
// 						}
// 						video {
// 							caption
// 							embed
// 							hash
// 							link
// 							platform
// 							thumbnail
// 							value
// 						}
// 						created_at
// 					}
// 					accepted_payment_types
// 					reviews(filter: { active: true }, sort: { created_at: -1 }) {
// 						_id
// 						author
// 						message {
// 							body
// 						}
// 						rating

// 						media {
// 							picture {
// 								hash
// 								value
// 								original
// 								caption
// 							}
// 							video {
// 								embed
// 								platform
// 								hash
// 								caption
// 								link
// 								thumbnail
// 							}
// 						}
// 						comments {
// 							from_client
// 							from_provider
// 							message
// 							created_at
// 						}
// 						verified
// 						created_at
// 					}
// 				}
// 				mostWeightedService {
// 					_id
// 					name
// 					credits
// 					active
// 					key
// 					phrase
// 					url
// 					slug
// 				}
// 				city {
// 					_id
// 					state
// 					name
// 					active
// 					url
// 				}
// 				popular_services {
// 					_id
// 					phrase
// 					url
// 				}
// 				nearby_cities {
// 					name
// 					url
// 				}
// 				related_services {
// 					phrase
// 					name
// 					url
// 				}

// 				reviews {
// 					_id
// 					author
// 					message {
// 						author
// 						body
// 					}
// 					service {
// 						name
// 					}
// 					rating
// 					client {
// 						_id
// 						image {
// 							hash
// 							value
// 						}
// 					}
// 					provider {
// 						_id
// 						company_name
// 					}
// 					media {
// 						picture {
// 							hash
// 							value
// 							original
// 							caption
// 						}
// 						video {
// 							embed
// 							platform
// 							hash
// 							caption
// 							link
// 							thumbnail
// 						}
// 					}
// 					comments {
// 						from_client
// 						from_provider
// 						message
// 						created_at
// 					}
// 					verified
// 					created_at
// 				}
// 			}
// 		}
// 	}
// `;

export const serviceQueryFragment = gql`
	fragment serviceQueryFragment on Service {
		_id
		name
		active
		credits
		key
		phrase
		url
		slug
		singular
		midtail
		name_proper
		affinities(filter: { show_in_search: true, active: true }) {
			affinity {
				_id
				name
				credits
				phrase
				active
				url
				slug
				singular
				midtail
				key
				weight
				name_proper
			}
		}
	}
`;

export const reviewsQueryFragment = gql`
	fragment reviewsQueryFragment on Review {
		_id
		author
		message {
			author
			body
		}
		service {
			name
		}
		rating
		client {
			_id
			first_name
			last_name
			image {
				hash
				value
				original
			}
		}
		provider {
			_id
			company_name
		}
		media {
			picture {
				hash
				value
				original
				caption
			}
			video {
				embed
				platform
				hash
				caption
				link
				thumbnail
			}
		}
		comments {
			message
			from_client
			from_provider
			created_at
		}
		verified
		created_at
	}
`;

export const countReviewsQueryFragment = true;

// export const providerQueryFragment = gql`
// 	fragment providerQueryFragment on Provider {
// 		_id
// 		metrics {
// 			hires
// 			reviews_avg
// 			reviews_count
// 		}
// 		key
// 		company_name
// 		company_founded
// 		image(approved: true) {
// 			hash
// 			value
// 		}
// 		services {
// 			name
// 			phrase
// 			url
// 		}
// 		qa {
// 			question
// 			answer
// 		}
// 		profile {
// 			slug
// 		}
// 		location {
// 			city
// 			state
// 			zip
// 		}
// 		verified {
// 			badge
// 			background
// 			email
// 			phone
// 		}
// 	}
// `;

export const providerServiceConfigurationsQueryFragment = gql`
	fragment providerServiceConfigurationsQueryFragment on ProviderServiceConfiguration {
		service {
			_id
			name
			name_proper
			credits
			key
			phrase
			url
			weight
		}
	}
`;

export const cityQueryFragment = gql`
	fragment cityQueryFragment on City {
		_id
		active
	}
`;

export const questionsQueryFragment = gql`
	fragment questionsQueryFragment on Question {
		_id
		type
		description
		quickPick
		text
		skip
		key
		tag {
			name
		}
		header
		answers(filter: { active: true }, sort: { position: 1 }) {
			_id
			type
			value
			tag_index
			subtext
			key
		}
	}
`;

export const findOpenLeadQueryFragment = gql`
	${quoteFragment}
	fragment findOpenLeadQueryFragment on Lead {
		_id
		key
		answers {
			_id
			answers
			values
			description
			tag_name
		}
		quotes(filter: $quotesFilter) {
			...quoteFragment
		}
		created_at
	}
`;

export const getProviderBusinessLocationMarkerMapQueryFragment = true;
